import { handleStatus500 } from 'api/Utility/HandleStatus500'
import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken, { getSessionToken } from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { textAnalysisTemplate } from 'containers/TextAnalysis/Template'

const { collectionIndex, userType, toolName } = textAnalysisTemplate

const axiosRequest = (extraParams: any = {}) => {
  const token =
    process.env.NODE_ENV === 'production' ? getSessionToken() : getToken()

  return AxiosInitializer({
    token,
    transformResConfig: false,
    paramsSerializerConfig: true,
    ...extraParams,
    tool: toolName,
  })
}

const taURL = {
  getTags: ({ attributes, source_id }: any) => {
    const defaultParams = {
      user_type: userType,
      source_id,
    }
    const queryParams = {
      scope_type: 'project',
      scope_id: attributes['project.id'],
    }
    return axiosRequest().get('tags', {
      params: { ...defaultParams, ...queryParams },
    })
  },
  createTags: ({ id, source_id, tags, attributes }: any) => {
    const defaultParams = {
      contribution_id: id,
      source_id,
      user_type: userType,
      collection_index: collectionIndex,
    }
    const queryParams = {
      scope: {
        scope_type: 'project',
        scope_id: attributes['project.id'],
      },
      tag: [tags],
    }
    return axiosRequest().post('tags', queryParams, {
      params: defaultParams,
    })
  },
  updateTags: ({ id, source_id, tags }: any) => {
    const defaultParams = {
      source_id,
      user_type: userType,
      collection_index: collectionIndex,
    }
    const queryParams = {
      scope: {
        key: 'id',
        value: id,
      },
      data: { tags },
    }
    return axiosRequest().put('contributions', queryParams, {
      params: defaultParams,
    })
  },
  bulkUpdateTags: ({ attributes, ...rest }: any) => {
    const defaultParams = {
      user_type: userType,
      collection_index: collectionIndex,
      source_id: rest.source_id,
    }
    const queryParams = {
      scope: {
        scope_type: 'project',
        scope_id: attributes['project.id'],
      },
      contribution_ids: rest.contribution_ids,
      tags: rest.tags,
    }
    return axiosRequest().post('contributions/bulk_tag', queryParams, {
      params: defaultParams,
    })
  },
}

const taTagsAPI = {
  getTags: (params = {}) =>
    apiWrapper({
      endPoint: taURL.getTags,
      params,
      errorFailureAction: handleStatus500,
    }),
  createTags: (params = {}) =>
    apiWrapper({
      endPoint: taURL.createTags,
      params,
      errorFailureAction: handleStatus500,
    }),
  updateTags: (params = {}) =>
    apiWrapper({
      endPoint: taURL.updateTags,
      params,
      errorFailureAction: handleStatus500,
    }),
  bulkUpdateTags: (params = {}) =>
    apiWrapper({
      endPoint: taURL.bulkUpdateTags,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default taTagsAPI
